import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import TableServerSideProvider from '~COMPONENTS/tableServerSide/TableServerSideContext';
import OrderIssuesList from './OrderIssuesList';

import { columnSortModifiersOrderIssues, columnFilterModifiersOrderIssues } from './orderIssueColumns';

export const OrderIssuesRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <TableServerSideProvider
          tableId='orderIssues'
          columnSortModifiers={columnSortModifiersOrderIssues}
          columnFilterModifiers={columnFilterModifiersOrderIssues}
        >
          <OrderIssuesList />
        </TableServerSideProvider>
      </Route>
    </Switch>
  );
};

export default OrderIssuesRoutes;
